import { ref } from "vue";

const isMobile = ref(false);
const isDesktop = ref(false);

export function useDevice() {
  const checkDevice = () => {
    isMobile.value = window.matchMedia("(max-width: 767px)").matches;
    isDesktop.value = window.matchMedia("(min-width: 768px)").matches;
  };

  checkDevice();

  // تحديث تلقائي عند تغيير حجم الشاشة
  window.addEventListener("resize", checkDevice);

  return {
    isMobile,
    isDesktop
  };
}
